import React from 'react';
import { FAQItem } from './FAQItem';
import { OrangeAccent } from './OrangeAccent';
const FAQS: {
  question: string;
  answer: string;
}[] = [{
  question: 'How does the 90-Day Guarantee actually work?',
  answer: "We install your Patient Profit System with one promise: if you don't see real revenue lift in 90 days, we keep working at our own cost until you do. No fine print, no escape clauses. We only take on clinics we're confident we can win for, which is why we screen carefully upfront."
}, {
  question: 'Who is this for — and who is it NOT for?',
  answer: "Best fit: established cash-pay clinics doing $40K+/month with a database of 2,000+ patients, owner-operator on site, willing to invest $2K+/mo in ads, and willing to film ~1 hour of content with us each month.\n\nNot for: brand-new clinics still figuring out their care model, owners who want to outsource everything including their voice, or anyone who treats marketing as 'magic pill' spend instead of a system."
}, {
  question: 'What happens on the Install Call and how should I prepare?',
  answer: "30 minutes. We look at your real numbers — last month's revenue, active patients, incomplete care plans — and map a 90-day install if it's a fit. Prep: jot down last month's revenue and your approximate active patient count. We plug those into your plan live on the call."
}, {
  question: 'Will this create more work for me or my front desk?',
  answer: 'No. Our U.S.-based appointment center handles confirmation, qualification, and rebooking before any new patient hits your calendar. Your front desk only sees patients who are already booked, confirmed, and ready. The only ongoing work for you is one ~hour-long content session per month.'
}, {
  question: 'What if I already have an agency, freelancer, or in-house marketer?',
  answer: "Most of our best clients came to us already paying multiple vendors. We consolidate. We don't ask you to fire anyone — we just show you which pieces are duplicating effort, and we replace the pieces that aren't producing patient revenue. Many clinics save more on consolidated vendor spend than the cost of working with us."
}, {
  question: "How fast can I expect results — and what if it doesn't work?",
  answer: 'Early signal in 30 days, fully installed system by day 90. Real numbers from current clients: 61 visits in 72 hours (Hawaii), $11K in week one (California), $117K → $144K/mo (Florida), 41 consults + 25% retention bump (Texas). If you hit the criteria we ask for and the system underperforms, see Q1 — we keep working until it does.'
}];
export function FAQSection() {
  return <section id="faq" className="w-full scroll-mt-20 py-20 md:py-28 px-4" data-id="element-54">
      <div className="max-w-[800px] mx-auto" data-id="element-55">
        <h2 className="font-display font-extrabold text-ink text-center leading-[1.1]" style={{
        fontSize: 'clamp(28px, 4vw, 44px)',
        letterSpacing: '-.02em'
      }} data-id="element-56">
          Frequently Asked <span className="text-orange" data-id="element-57">Questions</span>
        </h2>
        <div className="flex justify-center mt-3 mb-10" data-id="element-58">
          <OrangeAccent data-id="element-59" />
        </div>

        <div className="flex flex-col gap-[6px]" data-id="element-60">
          {FAQS.map(faq => <FAQItem key={faq.question} {...faq} data-id="element-61" />)}
        </div>
      </div>
    </section>;
}